var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-box",on:{"click":function($event){return _vm.goDetail(_vm.cellInfo)}}},[_vm._t("clickable-cell")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }